import type { ReactElement, ReactNode } from 'react';
import { Ctext } from '../Ctext';
import { TextPreset } from '@/constants/componentPresets';
import { FontWeight } from '@/theme/typography';
import { getTitleLeftStyle, getTitleRightStyle, getTitleWrapperStyle, } from './Cmodal.styles';
import { dataEl, type DataElScope } from '@/utils/dataEl';
interface CmodalTitleProps {
    dataElScope: DataElScope;
    menuTitle: string;
    titleExtra?: string;
    titleRightComponent?: ReactNode;
}
export function CmodalTitle({ dataElScope, menuTitle, titleExtra, titleRightComponent, }: CmodalTitleProps): ReactElement {
    return (
	      <div data-el={dataEl(dataElScope, 'Title/Root')} style={getTitleWrapperStyle({ hasRightComponent: Boolean(titleRightComponent) })}>
	        <div data-el={dataEl(dataElScope, 'Title/Left')} style={getTitleLeftStyle()}>
	        <Ctext preset={TextPreset.Strong} size={25} weight={FontWeight.Heavy}>
	          {menuTitle}
	        </Ctext>
	        {titleExtra && (<Ctext preset={TextPreset.Mild} size={21} weight={FontWeight.Light} opacity={0.55}>
	            {titleExtra}
          </Ctext>)}
      </div>
	      {titleRightComponent && (<div data-el={dataEl(dataElScope, 'Title/Right')} style={getTitleRightStyle()}>
	          {titleRightComponent}
        </div>)}
      </div>
    );
}
